export function calculateRate(
  dividend,
  divisor,
  { defaultRate = 0.0, exponents = 2 } = {}
) {
  let rate = defaultRate
  if (divisor > 0) {
    rate = 100.0 * (dividend / divisor)
    if (isNaN(rate)) {
      rate = defaultRate
    }
  }
  return rate.toFixed(exponents)
}
